// extracted by mini-css-extract-plugin
export default {"DisplayEvents":"TribeHome_DisplayEvents__2Z0VG"};